"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment TestimonialModule on EditorialTestimonialCarousel {\n    __typename\n    id\n    collection {\n      __typename\n      title\n      showStarRating\n      textCollection {\n        __typename\n        text\n        textLinks {\n          id\n          relativeUrl\n          title\n        }\n      }\n      author\n      image {\n        __typename\n        url\n        urlMobile\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.testimonialModuleFragment = void 0;
var _fetching = require("@ori/fetching");
const testimonialModuleFragment = exports.testimonialModuleFragment = (0, _fetching.gql)(_templateObject());
